<template>
  <div class="liveListBox">
    <div class="liveListBox-title">
      <h4>当前课程有以下直播正在进行中</h4>
<!--      <span>请选择进入</span>-->
    </div>
    <ul class="liveList">
      <li v-for="(item, index) in liveList" :key="index" @click="openLiveRoom(index)">
        <h5>{{item.name}}</h5>
        <p>
<!--          <span>{{ showTime(item.startTime) }}-{{ showTime(item.endTime) }}</span>-->
          <span>{{getLiveTime(item.startTime)}} - {{getLiveTime(item.endTime)}}</span>
          <span class="liveEntrance">
            <span class="liveEntranceText">进入直播</span>
            <van-icon name="arrow" />
          </span>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import { dateTime } from '../../../utils/tools';

export default {
  name: 'LiveListBox',
  props: ['liveList'],
  methods: {
    // ios 时间 '-' 处理
    iosTimeReplace(timeIt) {
      return (timeIt || '').replace(/-/g, '/');
    },
    // 转换时间
    showTime(time) {
      const temp = dateTime(new Date(this.iosTimeReplace(time)).getTime());
      return `${temp.year}.${temp.month}.${temp.day}`;
    },
    getLiveTime(time) {
      return time.slice(-8, -3);
    },
    openLiveRoom(index) {
      this.$emit('openLiveRoom', index);
    },
  },
};
</script>

<style lang="scss" scoped>
  .liveListBox {
    position: relative;
    width: 678px;
    height: auto;
    background-color: #fff;
    border: 2px solid #F3F3F3;
    box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.08);

    .liveListBox-title {
      padding: 80px 29px 29px;

      h4 {
        color: #333;
        font-weight: 600;
        font-size: 33px;
        text-align: center;
      }

      span {
        color: #787878;
        font-size: 22px;
      }
    }

    .liveList {
      max-height: 500px;
      padding: 0 29px 50px;
      overflow: auto;

      li {
        height: 125px;
        margin-bottom: 20px;
        padding: 29px 20px;
        background: #FFF8F2;
        border-radius: 7px;

        h5 {
          overflow: hidden;
          color: #333;
          font-weight: 600;
          font-size: 25px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        p {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
          span {
            color: #787878;
            font-size: 22px;
          }
          .liveEntrance {
            display: flex;
            align-items: center;
            color: #FF6C02;
            span{
              color: #FF6C02;
            }
            .liveEntranceText {
              padding-right: 8px;
            }
          }
        }
      }
    }
  }
</style>
